import script from "./ApiKeys.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiKeys.vue?vue&type=script&setup=true&lang=js"

import "./ApiKeys.vue?vue&type=style&index=0&id=5545b5f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5545b5f9"]])

export default __exports__